import { causes } from "@/mocks/home";
import SectionHeading from "@/components/feature/SectionHeading";

export default function Causes() {
  return (
    <section id="causes" className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-content px-4">
        <SectionHeading
          eyebrow="打不开的常见原因"
          title="先弄清楚，到底是哪里出了问题"
          desc="同一句「打不开」，背后的原因其实各不相同。先对照下面几类情况，判断自己属于哪一种，再按对应的方法处理，效率会高很多。"
        />

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {causes.map((item) => (
            <article
              key={item.id}
              className="rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-accent-200"
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-md bg-accent-100 text-accent-700">
                <i className={`${item.icon} text-xl`}></i>
              </span>
              <h3 className="mt-4 font-heading text-base font-bold text-foreground-950 md:text-lg">
                {item.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                {item.desc}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}